// -*-mode: rjsx -*-
// REACT
import React, { useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"
import FlashItem from "../Flash/FlashItem.js"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"

const useDefaultStyles = makeStyles(theme => ({
    subheaderDiv: {
        marginLeft: 25,
        marginRight: 25,
        marginTop: 20,
        marginBottom: 10,
        width: "90%",
//        backgroundColor: grey[800],
    },
    subheaderText: {
        fontSize: "1.25rem",
        fontWeight: 300,
        color: grey[800],
//        marginBottom: 5,
    },
}), { name: "FlashSubHeader" })

// keep adding this stuff

let FlashSubHeader = (props) => {

    // eslint-disable-next-line
    const { children, text1, text2,
            initialHeight=34,
          } = props

    const classes = {
        ...useDefaultStyles(),
    }

    useEffect(() => {
    })

    return (
        <div className={classes.subheaderDiv}>
          <div style={{display: "flex", alignItems: "center"}}>
                    <FlashItem
                      style={{backgroundColor: "#fafafa", width: "90%", maxHeight: initialHeight}}
                      clickBody={true} hasMore={false} hasLess={false} expanded={false} fadeout={false}>
                      {text1}
                      {children}
                    </FlashItem>
          </div>
        </div>
    )
}

export default FlashSubHeader

